export const SET_HAS_EDUCATION = 'SET_HAS_EDUCATION';

export const SetHasEducation = (value) => {
    return {
        type: SET_HAS_EDUCATION,
        payload: {
            value: value
        }
    }
}